import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=4f0a7062&scoped=true&lang=pug&"
import script from "./calendar.vue?vue&type=script&setup=true&lang=js&"
export * from "./calendar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=4f0a7062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a7062",
  null
  
)

export default component.exports